import React, { useState, useEffect, useRef } from 'react';
import InputWrapper from './InputWrapper';
import ImageWithBaseApi from 'components/common/mediaRender/ImageWithBaseApi';

const ImageUpload = ({ label, value, onFileChange, onRemoveImage, error, recommendedSize = '320 x 320 píxeles', id = 'imgInp' }) => {
  const [preview, setPreview] = useState(null);
  const fileInputRef = useRef(null);

  useEffect(() => {
    if (value instanceof File) {
      const objectUrl = URL.createObjectURL(value);
      setPreview(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    } else {
      setPreview(value);
    }
  }, [value]);

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };

  const isExternalLink = (url) => {
    try {
      new URL(url);
      return true;
    } catch (_) {
      return false;
    }
  };

  return (
    <InputWrapper label={label} error={error}>
      <div className="profile-upload">
        <div className="profile-upload-content d-flex align-items-center justify-content-start">
        {preview && (
          <div className="profile-upload-img">
            {isExternalLink(preview) ? (
              <img
              className="img-fluid shadow rounded"
              src={preview}
              alt="Vista previa"
              height="auto"
              width="120px"
            />
            ) : (
              <ImageWithBaseApi
              className="img-fluid shadow rounded"
              src={preview}
              alt="Vista previa cargada"
              height="auto"
              width="120px"
              loadingIconFontSize="30px"
            />

            )}
          </div>
        )}
        <div className="profile-upload-btn ms-3 d-flex justify-content-center">
            <div className="profile-upload-file btn btn-upload p-0">
              <input
                type="file"
                accept="image/*"
                onChange={onFileChange}
                id={id}
                autoComplete="off"
                ref={fileInputRef}
                style={{ display: 'none' }}
              />
              <button type="button" className="btn btn-primary-300 p-2 px-3" onClick={handleButtonClick}>Subir</button>
            </div>
            <button type="button" onClick={onRemoveImage} className="btn btn-outline-danger p-2 px-3">
              Eliminar
            </button>
          </div>
        </div>
      </div>
    </InputWrapper>
  );
};

export default ImageUpload;